import styled from 'styled-components';

export const InnerHtmlWrap = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
`;
